import AsyncLoader from 'component/AsyncLoader';

export const AccountFlow =  AsyncLoader(() => import('./AccountFlow'));
export const FinanceBalance =  AsyncLoader(() => import('./FinanceBalance'));